<template>
    <a-button type="primary" :size="size ? size : 'small'" @click="handleOpen">{{btn_text ? btn_text : '对比'}}</a-button>
    <a-modal
      :title="'对比'"
      v-model:visible="openDia" 
      :confirm-loading="loading"
      @cancel="onCancel"
      width="80%"
    > 
      <a-space style="margin: 10px;">
        <a-button :type="diff_type == 'parallel' ? 'primary' : 'default'" @click="diff_type = 'parallel'">并列对比</a-button>
        <a-button :type="diff_type == 'slide' ? 'primary' : 'default'" @click="diff_type = 'slide'">Slid 对比</a-button>
        <a-button :type="diff_type == 'fast' ? 'primary' : 'default'" @click="diff_type = 'fast'">Hover 对比</a-button>
        <div v-if="diff_type == 'fast'">
          <a-tag v-show="hover_switch" color="blue">before</a-tag>
          <a-tag v-show="!hover_switch" color="green">after</a-tag>
        </div>
      </a-space>
      <div v-show="diff_type == 'parallel'" class="diff-container" >
        <div style="width: 40%;">
          <a-image class="diff-image" :src="rawImage(show_target_image)" alt="对比图片" />
          <a-tag color="green">after_</a-tag>
        </div>
        <div style="width: 40%;">
          <a-image class="diff-image" :src="rawImage(show_origin_image)" alt="对比图片" />
          <a-tag color="blue">before</a-tag>
        </div>
      </div>
     <div class="diff-container" >
      <ImageDiff
        v-show="diff_type == 'slide'"
        :imageLeft="rawImage(show_origin_image)"
        :imageRight="rawImage(show_target_image)" />
     </div>

     <div  v-show="diff_type == 'fast'" class="diff-container" style="" @mouseenter="hover_switch = true" @mouseleave="hover_switch = false">
        <div v-show="hover_switch" style="width: 80%;" >
          <img class="img-diff-item" :src="rawImage(show_origin_image)" alt="对比图片" />
        </div>
        <div v-show="!hover_switch"  style="width: 80%;">
          <img class="img-diff-item" :src="rawImage(show_target_image)" alt="对比图片" />
        </div>
      </div>
    </a-modal>
  </template>
<script>
import ImageDiff from './ImageDiff.vue';
import { defineComponent, reactive, ref } from 'vue'
import request from '@/utils/request'
import { Modal, message } from 'ant-design-vue';
import OSS from 'ali-oss'
// import {CheckCircleOutlined,CloseCircleOutlined} from '@ant-design/icons-vue';
import { StyleNames} from '@/utils/macro'
import { rawImage} from '@/utils/image'


export default defineComponent({
  emits: ['ok'],
  props: ['origin_image', 'target_image', 'case_id', 'caseTargetImage', 'size' , 'btn_text'],
  // components:{CheckCircleOutlined,CloseCircleOutlined},
  data(){
    return {
      loading: false,
      openDia: false,
      hover_switch:false,
      StyleNames,
      diff_type: 'parallel',
      show_origin_image: '',
      show_target_image: '',
      // imageUrl: '',
    }
  },
  components: {
    ImageDiff,
  },
  mounted() {
    
    // this.imageUrl = this.modelValue
  },
  methods: {
    rawImage,
    async GetCase(){
      if (!this.case_id) {
        return
      }
      this.loading = true
      const rsp = await request.get(`/api/testcase/cases/${this.case_id}`)
      this.loading = false
      if (rsp.code == 0) {
        this.currentCase = rsp.data.item
        if (!this.origin_image) {
          this.show_origin_image = this.currentCase.work_image_key
        }
        if (this.caseTargetImage) {
          this.show_target_image = this.currentCase.work_image_key
        }
      } else {
        message.error(rsp.msg)
      }
    },
    onCancel: function(){
      this.openDia = false
      localStorage.setItem('diff_type', this.diff_type)
    },
    async handleOpen() {
      this.openDia = true
      let diff_type = localStorage.getItem('diff_type')
      if (diff_type) {
        this.diff_type = diff_type
      }
      console.log("this.origin_image", this.origin_image)
      console.log("this.target_image", this.target_image)
      this.show_origin_image = this.origin_image
      this.show_target_image = this.target_image
      if (!this.origin_image || this.caseTargetImage) {
        await this.GetCase()
      }
      
    }
  },
})
</script>
<style  scoped>
.diff-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: #EEE;
  text-align: center;
}
.diff-container:hover{
  cursor: pointer;
}
.diff-image {
  width: 450px;

}
.img-diff-item {
  width: 450px;
}
</style>
